let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("acn3S")).then(() => parcelRequire('c4uEB'));